import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/GlobalFilters/EditorData";
import {GlobalFilterRuleFormData} from '../../../integrated-client/models/';
import {shallowValidationCheck} from "../../../utils/ValidationUtils";

const updateEditorData: Reducer<EditorData> =
  (state: EditorData = new EditorData(), action: Action<ActionType, GlobalFilterRuleFormData>) => {
  switch (action.type) {
    case ActionType.GLOBAL_FILTERS_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.GLOBAL_FILTERS_EDITOR_DATA_FETCHED:
      return { ...state, editorData: action.data };
    case ActionType.GLOBAL_FILTERS_EDITOR_DATA_COPIED:
      return { ...state,  editorData: { ...action.data} };
    case ActionType.GLOBAL_FILTERS_EDITOR_DATA_UPDATED:
      return { ...state,  editorData: { ...state.editorData, ...action.data } };
    case ActionType.GLOBAL_FILTERS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.GLOBAL_FILTERS_EDITOR_DATA_VALIDATED:
      let isValid = shallowValidationCheck(action.data);
      return { ...state, validation: action.data, readyToSave: isValid };
    case ActionType.GLOBAL_FILTERS_EDITOR_DATA_SET_BRAND_AND_MARKET:
      return { ...state, editorData: {brandAndMarket: action.data} };
    default:
      return state;
  }
};

export default updateEditorData;
